export default __webpack_public_path__ + "static/media/moon.8ef4a4e2.svg";